import { render, staticRenderFns } from "./tradeHistoryList.vue?vue&type=template&id=48e81014&scoped=true"
import script from "./tradeHistoryList.vue?vue&type=script&lang=js"
export * from "./tradeHistoryList.vue?vue&type=script&lang=js"
import style0 from "./tradeHistoryList.vue?vue&type=style&index=0&id=48e81014&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e81014",
  null
  
)

export default component.exports